const MEMBRO_TIPO = {
    10: { id: '10', descricao: 'Diretor Presidente / Superintendente' },
    11: { id: '11', descricao: 'Diretor Vice Presidente/ Superintendente' },
    12: { id: '12', descricao: 'Diretor de Relações com Investidores' },
    13: { id: '13', descricao: 'Diretor Presidente / Diretor de Relações com Investidores' },
    19: { id: '19', descricao: 'Outros Diretores' },
    20: { id: '20', descricao: 'Presidente do Conselho de Administração' },
    21: { id: '21', descricao: 'Vice Presidente Conselho de Administração' },
    22: { id: '22', descricao: 'Conselho de Administração (Efetivo)' },
    23: { id: '23', descricao: 'Conselho de Administração (Suplente)' },
    24: { id: '24', descricao: 'Presidente do Conselho de Administração Independente' },
    25: { id: '25', descricao: 'Vice Presidente Conselho de Administração Independente' },
    27: { id: '27', descricao: 'Conselho de Administração Independente (Efetivo)' },
    28: { id: '28', descricao: 'Conselho de Administração Independente (Suplente)' },
    29: { id: '29', descricao: 'Outros Conselheiros' },
    30: { id: '30', descricao: 'Presidente do Conselho de Administração e Diretor Presidente' },
    31: { id: '31', descricao: 'Vice Presidente Conselho de Administração e Diretor Presidente' },
    32: { id: '32', descricao: 'Vice Presidente Conselho de Administração e Vice Dir. Presidente' },
    33: { id: '33', descricao: 'Conselheiro(Efetivo) e Dir. Presidente' },
    34: { id: '34', descricao: 'Conselheiro(Efetivo) e Dir. Vice Presidente' },
    35: { id: '35', descricao: 'Conselheiro(Efetivo) e Dir. Relações com Investidores' },
    36: { id: '36', descricao: 'Conselheiro(Suplente) e Dir. Presidente' },
    37: { id: '37', descricao: 'Conselheiro(Suplente) e Dir. Vice Presidente' },
    38: { id: '38', descricao: 'Conselheiro(Suplente) e Dir. Relações com Investidores' },
    39: { id: '39', descricao: 'Outros Conselheiros / Diretores' },
    40: { id: '40', descricao: 'Presidente Comissão Fiscal Eleito p/Controlador' },
    41: { id: '41', descricao: 'Presidente Comissão Fiscal Eleito p/Preferencialistas' },
    42: { id: '42', descricao: 'Presidente Comissão Fiscal Eleito p/Minor.Ordinaristas' },
    43: { id: '43', descricao: 'Comissão Fiscal(Efetivo) Eleito p/Controlador' },
    44: { id: '44', descricao: 'Comissão Fiscal(Efetivo) Eleito p/Preferencialistas' },
    45: { id: '45', descricao: 'Comissão Fiscal(Efetivo) Eleito p/Minor.Ordinaristas' },
    46: { id: '46', descricao: 'Comissão Fiscal(Suplent) Eleito p/Controlador' },
    47: { id: '47', descricao: 'Comissão Fiscal(Suplent) Eleito p/Preferencialistas' },
    48: { id: '48', descricao: 'Comissão Fiscal(Suplent) Eleito p/Minor.Ordinaristas' },
    90: { id: '90', descricao: 'Comitê' },
    99: { id: '99', descricao: 'Outros' }
};

module.exports = MEMBRO_TIPO;
